<p *ngIf="address">
  <span *ngIf="title" class="title">{{title}} <br/></span>
  <ng-container *ngIf="address?.name">
    <span class="name" style="font-weight: bold;"> {{address.name}} </span><br/>
  </ng-container>
  <ng-container *ngIf="address?.addressLine1">
    {{address.addressLine1}}<br/>
  </ng-container>
  <ng-container *ngIf="address?.zipCode && address?.city">
    {{address.zipCode}} {{address.city}}
  </ng-container>
</p>
